<template>
  <header
    :class="['navbar w-full transition-all duration-300 ease-out', navbarClasses, dynamicHeaderColor]"
    :style="headerStyles"
    role="navigation"
    aria-label="Main Navigation">
    <!-- Desktop Header -->
    <Header
      :logo-url="logoUrl"
      :locale="locale"
      :scrolled="props.scrolled"
      @update:locale="locale = $event"
      @toggle-drawer="toggleDrawer" />

    <!-- Backdrop -->
    <transition name="fade">
      <div v-if="isDrawerOpen" class="fixed inset-0 bg-black/50 z-40" @click="toggleDrawer" aria-hidden="true" />
    </transition>

    <!-- Mobile Drawer -->
    <transition name="fade">
      <HeaderMobileDrawer
        v-if="isDrawerOpen"
        :locale="locale"
        @update:locale="locale = $event"
        @toggle-drawer="toggleDrawer" />
    </transition>
  </header>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { setupLocale } from "@/utils/locale";
import Header from "./Header.vue";
import HeaderMobileDrawer from "./HeaderMobileDrawer.vue";

const props = withDefaults(
  defineProps<{
    isSticky?: boolean;
    scrolled?: boolean;
  }>(),
  {
    isSticky: false,
    scrolled: false,
  }
);

const locale = setupLocale();
const logoUrl = "/images/logo/logo-dark.svg";
const isDrawerOpen = ref(false);

const toggleDrawer = () => {
  isDrawerOpen.value = !isDrawerOpen.value;
};

const navbarClasses = computed(() => {
  if (!props.isSticky) return "relative";
  return props.scrolled ? "fixed top-0 z-50 shadow-lg" : "relative z-10";
});

const headerStyles = computed(() => {
  return props.scrolled ? { top: "0" } : {};
});

const dynamicHeaderColor = computed(() => {
  return props.scrolled ? "bg-gradient-to-r from-primary to-accent" : "bg-primary";
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
